export const REST_URL = window.REST_URL || 'http://localhost:62065/api/';
export const INITIATIVE_TYPE = 1;
export const CIP_TYPE = 2;

export const TRANSACTION_CIP_IDEA_TYPE = 1;
export const TRANSACTION_REPORT_TYPE = 2;


export const TRANSACTION_WITHDRAW_TYPE = 3;
export const TRANSACTION_DEPOSIT_TYPE = 4;


export const INITIATIVE_STATE_NEW = 1;
export const INITIATIVE_STATE_PAID = 4;

export const SUPPORT_LOCALES = ['en', 'sv', 'fi'];
export const DEFAULT_LOCALE = 'en';


export const convertInitiativeStateName = (stateIdx) => {
  if (stateIdx == -1) return 'Open';
  else if (stateIdx == INITIATIVE_STATE_NEW) return 'New';
  else if (stateIdx == 2) return 'In review';
  else if (stateIdx == 3) return 'Waiting To Be Implemented';
  else if (stateIdx == INITIATIVE_STATE_PAID) return 'Paid';
  else if (stateIdx == 5) return 'Rejected';
  else if (stateIdx == 6) return 'Waiting For Commitee';
  else if (stateIdx == 7) return 'All';
  return 'Open';
};


export const convertCipIdeaStateName = (stateIdx) => {
  if (stateIdx == -1) return 'Open';
  else if (stateIdx == 0) return 'New';
  else if (stateIdx == 1) return 'Pending';
  else if (stateIdx == 2) return 'Ready';
  else if (stateIdx == 3) return 'Rejected';
  return 'Open';
};

export const encodeData = filter => Object.keys(filter).map(key => [key, filter[key]].map(encodeURIComponent).join('=')).join('&');

export const detectBrowserLocale = () => {
  if (window.localStorage) {
    const locale = localStorage.getItem('locale');
    if (locale && SUPPORT_LOCALES.indexOf(locale) >= 0) {
      return locale;
    }
  }
  let language = window.navigator.userLanguage || window.navigator.language;
  if (language && language.indexOf('-') >= 0) {
    language = language.split('-')[0];
    if (language && SUPPORT_LOCALES.indexOf(language) >= 0) {
      return language;
    }
  }
  if (language && SUPPORT_LOCALES.indexOf(language) >= 0) {
    return language;
  }
  return SUPPORT_LOCALES[0];
};



// WEBPACK FOOTER //
// ./constants.js